import React, { useEffect, useState } from "react";
import AddSafeZone from "./AddSafeZone";
import Zones from "./Zones";
import {
  getGeoFenceData,
  getLocationPermission,
} from "../../../AxiosRtk/Location";
import Swal from "sweetalert2";
import useFirebase from "../../../../../useFirebase";
import { useDispatch, useSelector } from "react-redux";
import useGeoLocation from "./useGeoLocation";
import { setShowInfo } from "../../../AxiosRtk/successMessage";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";

const Location = ({ deviceSelected, getLangTranslation }) => {
  const dispatch = useDispatch();
  const [isLocationEnabled, setIsLocationEnabled] = useState(0);
  const [allFireStoreData, setAllFireStoreData] = useState(null);
  const [isAddSaveZone, setIsAddSaveZone] = useState(false);
  const [locationgeofendingsettings, setLocationgeofendingsettings] =
    useState(null);
  const [locationData, setLocationData] = useState(null);
  const { getCollectionData } = useFirebase(deviceSelected);
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [editData, setEditData] = useState({
    isEditMode: false,
    item: {},
  });
  const { kidList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );
  const { handleToggleChange, addEditData, deleteLocationData } =
    useGeoLocation(
      deviceSelected,
      locationData,
      setLocationData,
      allFireStoreData
    );

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null))
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      setLocationData(setRulesData?.geoLocationData);
      setLocationgeofendingsettings(setRulesData?.locationgeofendingsettings);
      setAllFireStoreData(setRulesData);
    } else {
      setLocationData(null);
      setLocationgeofendingsettings(null);
      setAllFireStoreData(null);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (deviceSelected) {
      getLocationPermission({ deviceId: deviceSelected })
        .then((res) => {
          setIsLocationEnabled(
            res?.data?.result?.find((item) => parseInt(item?.PermissionID) === 6)
              ?.IsEnabled || 0
          );
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    } else {
      setIsLocationEnabled(0)
    }
  }, [deviceSelected]);

  const handleExit = () => {
    setIsAddSaveZone(false);
    setEditData({ isEditMode: false, item: {} });
  };

  const handleEdit = (item) => {
    setIsAddSaveZone(true);
    setEditData({ isEditMode: true, item: item });
  };

  if (!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
      </div>
    )
  }


  return (
    <>
      {!isAddSaveZone && (
        <>
          {" "}
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer"
                id="LOCATION_ENABLE"
                type="checkbox"
                role="switch"
                name="LOCATION_ENABLE"
                onChange={(e) => {
                  if (isLocationEnabled) handleToggleChange(e);
                  else
                    dispatch(
                      setShowInfo({
                        showInfo: true,
                        defaultMessage:
                          "Please enable location permission on child's device",
                        message:
                          "SELECT_CHILD_PLEASE_ENABLE_LOCATION_PERMISSION_ON_CHILD_DEVICE",
                      })
                    );
                }}
                checked={locationgeofendingsettings?.geoLocationEnable || 0}
              />
              <label
                className="form-check-label text-blue-800 fw-semibold"
                htmlFor="activateGeoFence"
              >
                {getLangTranslation("LOCATION_SETTINGS_ENABLE_LOCATION", "Enable location")}
              </label>
            </div>
            <button
              className="btn btn-primary d-inline-flex align-items-center gap-1"
              onClick={(e) => {
                if (isLocationEnabled) setIsAddSaveZone(true);
                else
                  dispatch(
                    setShowInfo({
                      showInfo: true,
                      defaultMessage:
                        "Please enable location permission on child's device",
                      message:
                        "SELECT_CHILD_PLEASE_ENABLE_LOCATION_PERMISSION_ON_CHILD_DEVICE",
                    })
                  );
              }}
            >
              <i className="icon-plus fs-5" />
              <span className="btn-upper-case">{getLangTranslation("LOCATION_SETTINGS_BTN_TXT", "Add Save Zone Location")}</span>
            </button>
          </div>
          {
            !!locationgeofendingsettings?.geoLocationEnable && (
              <Zones
                locationData={locationData}
                handleEdit={handleEdit}
                deleteLocationData={deleteLocationData}
                getLangTranslation={getLangTranslation}
              />
            )
          }
        </>
      )}
      {isAddSaveZone &&
        //   isLocationEnabled &&
        locationgeofendingsettings?.geoLocationEnable ? (
        <AddSafeZone
          handleExit={handleExit}
          deviceSelected={deviceSelected}
          isEdit={editData?.isEditMode}
          item={editData?.item}
          addEditData={addEditData}
          getLangTranslation={getLangTranslation}
        />
      ) : (
        null
      )}
    </>
  );
};

export default Location;
